import theme from "../../../styles/theme"
const { colors } = theme

export default (props) => {
    return (`
    font-family: ${theme.font.bold}, "Helvetica Neue", Helvetica, Arial,
        sans-serif;
    ${props.bold ? `font-family: ${theme.font.bold};` : ``}
    ${props.semiBold ? `font-family: ${theme.font.semiBold};` : ``}
    ${props.regular ? `font-family: ${theme.font.regular};` : ``}
    ${props.recoleta ? `font-family: ${theme.font.recoletaSemiBold};` : ``}
    ${props.recoletaSemiBold ? `font-family: ${theme.font.recoletaSemiBold};` : ``}
    ${props.recoletaBold ? `font-family: ${theme.font.recoletaBold};` : ``}

    a {
        ${props.bold ? `font-family: ${theme.font.bold};` : ``}
        ${props.semiBold ? `font-family: ${theme.font.semiBold};` : ``}
        ${props.regular ? `font-family: ${theme.font.regular};` : ``}
    }
    strong {
        font-family: "ProximaNova-Bold";
    }
    color: ${props.color ? colors[props.color] : colors.grayscale.main};
    
    text-align: ${props.textAlign ? props.textAlign : "auto"};
`)
}

